<template>
  <div class="grid grid-cols-2 gap-2 md:grid-cols-3">
    <nuxt-link
      v-for="topic in topics"
      :key="topic.uuid"
      :to="
        toLocalePath({
          name: 'magazine',
          query: {
            tag: topic.uuid,
          },
        })
      "
      class="col-span-1 flex justify-between gap-1 bg-black px-8 py-2"
      @click="
        trackBlogTopic({
          blog_article_category: topic.name || '',
          blog_section: 'Themenwelt',
        })
      "
    >
      <div class="flex-1 overflow-hidden break-words text-base text-white">
        {{ getName(topic) }}
      </div>
      <div
        class="-my-1 -mr-6 flex size-8 shrink-0 items-center justify-center rounded-full bg-white"
      >
        <Icon icon="arrow-right" class="size-4" />
      </div>
    </nuxt-link>
  </div>
</template>

<script lang="ts">
import { useDeviceType } from '~/composables/useDeviceType'
import type {
  StoryblokStory,
  Sbtag,
} from '~/cms/storyblok/types/storyblok.d.ts'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'

export default defineComponent({
  props: {
    topics: {
      type: Array as PropType<StoryblokStory<Sbtag>[]>,
      default: () => [],
    },
  },
  setup() {
    const { isMobile } = useDeviceType()
    const { trackBlogTopic } = useTrackingEvents()
    const { locale } = useCurrentShop().value
    const { toLocalePath } = useRouteHelpers()

    return {
      toLocalePath,
      isMobile,
      trackBlogTopic,
      getName: (tag: StoryblokStory<Sbtag>) => {
        return (
          tag.translated_slugs.find((slug) => slug.lang === locale)?.name ||
          tag.name
        )
      },
    }
  },
})
</script>
